import { FunctionComponent } from 'react';
import { usePagination } from '@starjack/shared-components';
import { Box, Typography } from '@mui/material';
import { Ticket } from '@/models/ticket';
import { TicketsOverviewUI } from '@/components/TicketsOverviewUI/TicketsOverviewUI';
import { useGetAllLiftOperatorsQuery } from '@/api/v2/liftOperator';
import { useGetTicketsQuery } from '@starjack/entities/ticket';

type OrderDetailsTicketsTableProps = {
    orderId: string;
    userId: string;
};

export const OrderDetailsTicketsTable: FunctionComponent<
    OrderDetailsTicketsTableProps
> = ({ orderId, userId }) => {
    const { data: tickets, error } = useGetTicketsQuery({ orderId, userId });
    const {
        currentItems: currentTickets,
        itemsPerPage: ticketsPerPage,
        setNextPage: setTicketsPage,

        countTotal,
        setItemsPerPage,
    } = usePagination({
        items: tickets?.content || [],
        itemsPerPage: 10,
    });
    const { data: liftOperators } = useGetAllLiftOperatorsQuery();

    return (
        <Box>
            <Typography
                sx={{
                    mb: 4,
                }}
                variant='h5'
            >
                Tickets
            </Typography>

            <TicketsOverviewUI
                currentPageTickets={
                    currentTickets.map((ticket) => ({
                        ...ticket,
                        liftOperatorId: '',
                    })) as unknown as Ticket[]
                }
                ticketsTotal={countTotal}
                ticketsPerPage={ticketsPerPage}
                onPageSizeChange={(nextValue) => {
                    setItemsPerPage(nextValue);
                }}
                onPageChange={(nextValue) => {
                    setTicketsPage(nextValue);
                }}
                ticketsLoading={false}
                error={error}
                liftOperators={liftOperators}
            />
        </Box>
    );
};
